import { AssignAutomatedQARules, DefaultScorecardAndAutoQARules, AssignDefaultScorecard, AutoQARule, NewAutoQARule, UserAllocatedAutoQARule, upsertUserAndGroupsToAutoQARule } from "../types/automatedQA/AutomatedQA";
import { axiosWithAuth } from "../utils/customAxios";

const autoqarulesService = {
  fetchAllAutoQARules: async (): Promise<AutoQARule[]> => {
    try {
      const response = await axiosWithAuth.get("/AutomatedQA/rule");
      return response.data;
    } catch (err) {
      throw err;
    }
  },

  fetchAllUserAllocatedAutoQARules: async (): Promise<UserAllocatedAutoQARule[]> => {
    try {
      const response = await axiosWithAuth.get("/AutomatedQA/UserAllocation");
      return response.data;
    } catch (err) {
      throw err;
    }
  },

  createNewAutoQARule: async (data: NewAutoQARule): Promise<AutoQARule> => {
    try {
      const response = await axiosWithAuth.post("/AutomatedQA/Rule", data);
      return response.data;
    } catch (err) {
      throw err;
    }
  },

  deleteAutoQARule: async (ruleId: number): Promise<AutoQARule> => {
    try {
      const response = await axiosWithAuth.delete(`/AutomatedQA/Rule/${ruleId}`);
      return response.data;
    } catch (err) {
      throw err;
    }
  },

  updateAutoQARule: async (data: NewAutoQARule, autoQARuleId: number): Promise<AutoQARule> => {
    try {
      const response = await axiosWithAuth.put(`/AutomatedQA/Rule/${autoQARuleId}`, data);
      return response.data;
    } catch (err) {
      throw err;
    }
  },

  assignDefaultScorecard: async (data: AssignDefaultScorecard[]): Promise<UserAllocatedAutoQARule[]> => {
    try {
      const response = await axiosWithAuth.post("/AutomatedQA/UserAllocation/DefaultScoreCard", data);
      return response.data;
    } catch (err) {
      throw err;
    }
  },

  assignAutomatedQARules: async (data: AssignAutomatedQARules[]): Promise<UserAllocatedAutoQARule[]> => {
    try {
      const response = await axiosWithAuth.post("/AutomatedQA/UserAllocation/Rules", data);
      return response.data;
    } catch (err) {
      throw err;
    }
  },

  assignUserAndGroupsToAutoQARule: async (data: upsertUserAndGroupsToAutoQARule, ruleId: number): Promise<AutoQARule> => {
    try {
      const response = await axiosWithAuth.post(`/AutomatedQA/RuleAllocation/UsersAndGroups/${ruleId}`, data);
      return response.data;
    } catch (err) {
      throw err;
    }
  },

  assignDefaultScorecardAndAutomatedQARules: async (data: DefaultScorecardAndAutoQARules[]): Promise<UserAllocatedAutoQARule[]> => {
    try {
      const response = await axiosWithAuth.post("/AutomatedQA/UserAllocation/DefaultScoreCardAndAutoQARules", data);
      return response.data;
    } catch (err) {
      throw err;
    }
  },
}

export default autoqarulesService;